<div nxModalContent>
    <h3 nxHeadline="subsection-medium" class="nx-margin-bottom-30">Endorsement Narration</h3>
    <div [innerHTML]="safeEndtNarration" class="narration-content"></div>

    <button nxButton="secondary" (click)="close()" class="nx-margin-right-s nx-margin-top-50">
      Cancel
    </button>
  </div>